import { render, staticRenderFns } from "./CreateKeyModal.vue?vue&type=template&id=56ea48b9"
import script from "./CreateKeyModal.vue?vue&type=script&lang=js"
export * from "./CreateKeyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports